import React from 'react';
import Logos from '../../logos';
import ProjectBlurb from '../project-blurb';
import Reveal from '../../reveal';
import RevealSlideDown from '../../../components/animations/reveal-slide-down';
import RevealEdges from '../../animations/reveal-edges';
import { css } from 'emotion';
import styles from './project-logo-work.module.css';

const ProjectLogoWorkContent = props => {
  const { slug, color, blurb, wrapperPadding, isInView, animation } = props;
  return (
    <div style={animation}>
      <div style={{ padding: wrapperPadding, position: 'relative' }}>
        <RevealEdges isInView={isInView} />
        <div className={styles.logos}>
          <div
            className={css`
              position: relative;
              width: 50%;
              padding-bottom: 50%;
              float: left;
              height: 0;
              & path {
                fill: #${color};
              }

              & polygon {
                fill: #${color};
              }
            `}
          >
            <div className={styles.inner} style={{ background: '#ffffff' }}>
              <Logos slug={`${slug}-work`} />
            </div>
          </div>
          <div
            className={css`
              position: relative;
              width: 50%;
              padding-bottom: 50%;
              float: left;
              height: 0;
              & path {
                fill: #ffffff;
              }

              & polygon {
                fill: #ffffff;
              }
            `}
          >
            <div className={styles.inner} style={{ background: `#${color}` }}>
              <Logos slug={`${slug}-work`} />
            </div>
          </div>
        </div>
        <ProjectBlurb blurb={blurb} />
      </div>
    </div>
  );
};

const ProjectLogoWork = props => {
  return (
    <Reveal>
      <RevealSlideDown>
        <ProjectLogoWorkContent {...props} />
      </RevealSlideDown>
    </Reveal>
  );
};

export default ProjectLogoWork;



// WEBPACK FOOTER //
// ./src/components/project/project-logo-work/index.js